import { Seo } from "@/lib/seo";
import { PageHero } from "@/components/page-hero";
import { CtaBlock } from "@/components/cta";
import { Reveal } from "@/lib/motion";
import { IMAGES } from "@/content/images";
import { SITE } from "@/content/site";

const PRINCIPIOS = [
  {
    titulo: "Primero escuchar",
    detalle:
      "Antes de clasificar un asunto hay que entender la vida que hay detrás. Empezamos por ahí, siempre.",
  },
  {
    titulo: "Decir la verdad",
    detalle:
      "Sobre el alcance, el costo y las probabilidades. Preferimos perder un cliente antes que inventar una expectativa.",
  },
  {
    titulo: "Orden antes que drama",
    detalle:
      "La mayoría de los problemas legales se resuelven con método y documentos, no con confrontación.",
  },
  {
    titulo: "El acuerdo, si es posible",
    detalle:
      "Donde hay acuerdo digno, el acuerdo protege mejor que el litigio. Litigiamos cuando es necesario, no por deporte.",
  },
];

export default function Nosotros() {
  return (
    <>
      <Seo
        title="Conoce Tulevik"
        description="Tulevik Legal es un despacho para momentos de vida reales: personas, familias y negocios que necesitan orden jurídico con trato humano."
        path="/nosotros"
      />
      <PageHero
        eyebrow="El despacho"
        titulo="Un despacho para momentos de vida reales"
        lead="Tulevik nace de una convicción sencilla: la mayoría de la gente no llega al abogado por un litigio espectacular, sino por una casa, una pareja, un trabajo o una herencia. Ahí es donde queremos estar."
      />

      <section className="bg-parchment">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 sm:py-24">
          <div className="grid items-start gap-12 lg:grid-cols-12 lg:gap-16">
            <div className="lg:col-span-5">
              <Reveal>
                <div className="border border-hairline bg-parchment-surface p-2.5">
                  <img
                    src={IMAGES.interiorArco}
                    alt="Interior arquitectónico con luz cálida"
                    className="h-[300px] w-full object-cover sm:h-[400px]"
                    loading="lazy"
                  />
                  <p className="px-3 py-3 font-mono text-[10px] uppercase tracking-[0.22em] text-azul">
                    {SITE.ubicacion}
                  </p>
                </div>
              </Reveal>
            </div>

            <div className="lg:col-span-7">
              <Reveal>
                <p className="text-lg leading-relaxed text-ink-muted">
                  Trabajamos con personas que construyen: quien compra su primera casa, quien
                  emprende, quien cría a una familia, quien cuida a sus padres y quien planea dejar
                  ordenado lo suyo. Nuestro nombre viene del esteón “tulevik”, futuro: la idea de que
                  un asunto legal bien resuelto es, sobre todo, un futuro bien cuidado.
                </p>
                <p className="mt-5 text-lg leading-relaxed text-ink-muted">
                  Nos organizamos por momentos de vida en lugar de por códigos de la ley, porque así
                  es como la gente realmente llega: “me llegaron los papeles de la casa”, “la relación
                  terminó”, “me debo de pagar desde hace tres meses”. Desde ahí elegimos la
                  herramienta jurídica correcta.
                </p>
                <p
                  className="mt-8 border-l-2 border-salvia-marco pl-5 font-serif text-2xl italic leading-snug text-azul"
                  data-testid="nosotros-lema"
                >
                  “{SITE.lema}”
                </p>
              </Reveal>

              <div className="mt-14 grid gap-10 sm:grid-cols-2">
                {PRINCIPIOS.map((p, i) => (
                  <Reveal key={p.titulo} delay={i * 0.06} y={16}>
                    <div className="border-t-2 border-ink-deep pt-5" data-testid={`principio-${i}`}>
                      <h3 className="font-serif text-xl text-ink-deep">{p.titulo}</h3>
                      <p className="mt-2 text-sm leading-relaxed text-ink-muted">{p.detalle}</p>
                    </div>
                  </Reveal>
                ))}
              </div>

              <Reveal className="mt-14">
                <div className="border border-hairline bg-parchment-surface/60 p-8" data-testid="equipo-nota">
                  <p className="eyebrow mb-4">El equipo</p>
                  <p className="text-ink-muted">
                    Estamos preparando el perfil público del equipo. Preferimos publicarlo hasta que
                    cada nombre, cédula y credencial esté verificado — tal como pedimos que se trate
                    tu asunto: con datos ciertos.
                  </p>
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </section>

      <CtaBlock />
    </>
  );
}
